(function () {
  const state = { moved: false };

  function findFilters(root = document) {
    const sels = [
      'form.faceted-filter-form',
      '.faceted-filter-form',
      '#FacetFiltersForm',
      '[data-faceted-filtering]',
      '.collection__filters',
      '.block__faceted-filtering',
      '.sidebar__block.block__faceted-filtering',
      '.sidebar__block.block__tag_filter'
    ];
    for (const s of sels) {
      const el = root.querySelector(s);
      if (el) return el;
    }
    return null;
  }

  const isEditor = () => typeof Shopify !== 'undefined' && Shopify.designMode;
  const isMobile = () => window.matchMedia('(max-width:1024px)').matches || isEditor();

  function els() {
    return {
      drawer: document.getElementById('filters-drawer'),
      target: document.querySelector('#filters-drawer .filters-drawer__inner'),
      backdrop: document.querySelector('.filters-backdrop'),
      btn: document.querySelector('.filters-toggle'),
    };
  }

  function moveIntoDrawer() {
    if (state.moved) return;
    const section = document.querySelector('[id^="shopify-section-"][class*="collection"]') || document;
    const src = findFilters(section) || findFilters(document);
    const { target } = els();
    if (src && target) {
      target.appendChild(src);
      state.moved = true;
    }
  }

  function openDrawer() {
    const { drawer, backdrop, btn } = els();
    if (!drawer || !backdrop) return;

    if (!isMobile()) {
      const f = findFilters(document);
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    moveIntoDrawer();
    drawer.hidden = false;
    backdrop.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.classList.add('has-drawer');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closeDrawer() {
    const { drawer, backdrop, btn } = els();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('has-drawer');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      if (drawer) drawer.hidden = true;
      if (backdrop) backdrop.hidden = true;
    }, 250);
  }

  // ✅ Delegated events (werken ook na section reloads)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.filters-toggle')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('.filters-close') || e.target.closest('.filters-backdrop')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Editor: bij section-reload opnieuw verplaatsen toegestaan
  document.addEventListener('shopify:section:load', () => { state.moved = false; });
})();
